<style>
	.userInfo {
		position: relative;
		width: 300px;
		height: 100px;
		margin-bottom: 10px;
		border-radius:10px;
		background-color: #ffffff;
	}
	.userInfo .userInfoImg {
		position: absolute;
		width: 50px;
		height: 50px;
		left: 60px;
		top: 50%;
		margin-top: -25px;
		cursor: pointer;
	}
	.userInfo .userInfoTitle {
		position: absolute;
		display: inline-block;
		left: 126px;
		top: 25px;
		font-size: 16px;
		color: #4D4D4D;
		width: 120px;
		text-align: left;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		cursor: pointer;
	}
	.userInfo .userInfoOther {
		position: absolute;
		display: inline-block;
		left: 126px;
		bottom: 25px;
		font-size: 13px;
		color: #4D4D4D;
	}
	.userInfo .userInfoMe {
		margin-left: 20px;
		color: #5147E7;
    cursor: pointer;
	}
</style>

<template>
	<div class="userInfo">
		<img class="userInfoImg" @click="gotoPersen" :src="userInfo.logo_url?userInfo.logo_url:require('../assets/logo.png')" alt="" />
		<span class="userInfoTitle" @click="gotoPersen">{{userInfo.name}}的商城</span>
		<span class="userInfoOther">
			<span>{{identity}}</span><span @click="changeInfo" class="userInfoMe">个人资料</span>
		</span>
	</div>
</template>

<script>
	import autoLogin from '../util/autoLogin.js'
	export default {
		components:{
			
		},
		props:['userInfo'],
		data() {
			return {

			}
		},
		computed: {
      identity(){
        let that=this
        switch (that.userInfo.identity){
          case 1:
            return "木工"
            break
          case 2:
            return "门店"
            break
          case 3:
            return "柜柜工厂"
            break
          case 4:
            return "柜门厂"
            break
          case 5:
            return "设备商"
            break
          case 6:
            return "材料厂"
            break
          case 7:
            return "软件服务点"
            break
          case 8:
            return "其他"
            break
          case 0:
            switch (that.userInfo.edition){
              case "木工版":
                return '木工'
                break
              case '设计版':case '设计版':
                return '门店'
                break
              case '工厂版':case '全能版':
                return '柜柜工厂'
                break
              default:
                return "未设置"
            }
        }
      }
		},
		mounted() {
      let that=this
			that.$post("/guigui/user/action_log",{
			  data:JSON.stringify({
			  uid:localStorage.getItem('data')?JSON.parse(localStorage.getItem('data')).id:-1,
			  platform:6,
			  type:"柜柜圈",
			  sub_type:"",
			  value:""
			})},res => {})
		},
		methods: {
			changeInfo(){
				this.$emit('changeNavInfo',"modified")
			},
			gotoPersen(){
				if (!localStorage.getItem('data')) {
					this.gotoLogin();
					return;
				}
				const userInfo = JSON.parse(localStorage.getItem('data'));
        		window.location.href = `https://s.eggi.cn/exhibition/index.html?fid=${userInfo.id}&${autoLogin.makeEnP(userInfo.phone)}`
			},
			gotoLogin(){
        		let pageTo=encodeURIComponent(location.href)
				location.href="./login.html?pageTo="+pageTo
      		}
		}
	}
</script>
